<template>
  <v-container>
    <div class="text-wrapper">
      <p>
        There are no lenders that match your criteria. This could be due to regulatory issues, credit score or other varying factors. <strong>Although, we were unable to get an exact match to one of our lenders, we encourage you to reach out to one of our top rated lending partners to review your situation.</strong>
      </p>
    </div>

    <h2>
      Featured lenders:
    </h2>

    <div class="grid-wrapper">
      <lender-card-layout
        v-for="match in matches"
        :key="match.product.title">
        <template #logo v-if="match.product.logo" >
          <div class="boxed-image standout">
            <img :src="match.product.logo" />
          </div>
        </template>

        <template #score>
          <p>Customer Reviews</p>
          <h1>
            {{ (match.product.scoreAverage && match.product.scoreAverage.toFixed(2)) || 0 }}
          </h1>
          <p class="subdued">average score</p>
          <star-rating
            :rating="match.product.scoreAverage"
            :editable="false"
            :count="match.product.reviewCount || 0"
          ></star-rating>
        </template>

        <template #infoButton>
          <router-link
            class="default-btn text"
            :to="{ name: 'Lender', params: { productId: match.product.id }}"
          >View Lender Details</router-link>
        </template>
      </lender-card-layout>
    </div>
  </v-container>
</template>

<script>
import LenderCardLayout from './LenderCardLayout'

export default {
  name: 'NoResults',
  components: {
    LenderCardLayout,
  },
  props: {
    dealId: String,
    matches: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding-top: 60px;
  padding-bottom: 60px;
}

.grid-wrapper {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;

  grid-column-gap: 40px;
  grid-row-gap: 40px;

  justify-content: center;
  align-items: center;

  @include mdOnly {
    grid-template-columns: auto auto;
    grid-column-gap: 20px;

    & > *:nth-child(3) {
      @include gridPos(2, 3, 1, 3);
      margin: auto;
    }
  }

  @include lg {
    grid-template-columns: auto auto auto;
  }

  .boxed-image {
    margin: 10px auto 0;
  }
}

.text-wrapper {
  padding: 30px;

  border: 3px solid $accentBlue;
  border-radius: 4px;
  background-color: white;

  p {
    @include lg {
      font-size: 22px;
      line-height: 26px;
    }
  }
}

h2 {
  align-self: flex-start;
  margin: 60px 0;

  color: $textDarkMuted;
}
</style>
